// @flow

import type { IncomingPayment, OpenedIncomingPayment } from './types';

export function getSafeAllowedPaymentTypes(incomingPayment: OpenedIncomingPayment): ImmutableArray<string> {
  const allowedPaymentTypes = incomingPayment['allowed_payment_types'];
  if(!allowedPaymentTypes)
    throw new Error('Allowed Payment Types: no allowed payment types for opened payment');

  return allowedPaymentTypes;
}

export function getAllowedPaymentTypes(incomingPayment: IncomingPayment): ImmutableArray<string> {
  if (incomingPayment.status === 'OP')
    return incomingPayment['allowed_payment_types'] || [];

  return [];
}
